import { render, staticRenderFns } from "./realTimeVideo.vue?vue&type=template&id=4d80e555&scoped=true&"
import script from "./realTimeVideo.vue?vue&type=script&lang=js&"
export * from "./realTimeVideo.vue?vue&type=script&lang=js&"
import style0 from "./realTimeVideo.vue?vue&type=style&index=0&id=4d80e555&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80e555",
  null
  
)

export default component.exports